/* camera */
/*--------------------------------------------------------------------------------*/
export const takePhoto = () => new Promise<{ image: string; }>((resolve) => {
    // set hash
    window.onhashchange = () => {
        if (window.location.hash != '#camera') closeCam();
    };
    window.location.hash = 'camera';
    // create
    const cam = camCreate();
    const video = cam.querySelector<HTMLVideoElement>('#video');
    let imgData: string;
    let stream: void | MediaStream;
    let front = false;
    const options = {
        video: {
            facingMode: 'environment',
            width: { ideal: 1024 },
            height: { ideal: 768 },
        }
    };
    const closeCam = () => {
        stopMedia();
        camClose(cam);
        resolve({ image: imgData });
    };
    const stopMedia = () => {
        if (stream) {
            const track = stream.getTracks()[0];
            track.stop();
        }
    };
    const startMedia = async () => {
        const title = cam.querySelector<HTMLElement>('.header .title');
        const detail = cam.querySelector<HTMLElement>('.header .detail');
        const footer = cam.querySelector<HTMLElement>('.footer');
        const body = cam.querySelector<HTMLElement>('.body');
        stream = await navigator.mediaDevices.getUserMedia(options).catch(() => {
            title!.innerText = 'ไม่พบกล้องถ่ายภาพ';
            footer!.style.display = 'none';
            body!.innerHTML = /*html*/ `
                <i class="icon thin" style="font-size: 80px;">&#xf8c4;</i>
            `;
        });
        if (stream) {
            video!.srcObject = stream;
            video!.play();
            const media = stream.getTracks()[0].getSettings();
            detail!.innerText = `${media.width}x${media.height} ${media.frameRate}fps`;
        }
    };
    // start media
    (async () => {
        await startMedia();
        camReady(cam);
    })();
    // button
    const btn_take = cam.querySelector<HTMLButtonElement>('#btn-take');
    const btn_flip = cam.querySelector<HTMLElement>('#btn-flip');
    const btn_close = cam.querySelector<HTMLElement>('#btn-close');
    const btn_cancel = cam.querySelector<HTMLElement>('#btn-cancel');
    // btn-take
    btn_take!.onclick = () => {
        const media = stream!.getTracks()[0].getSettings();
        const image = cam.querySelector<HTMLCanvasElement>('#image');
        // init image
        const ctx = image!.getContext('2d');
        ctx!.clearRect(0, 0, image!.width, image!.height);
        image!.width = Number(media.width);
        image!.height = Number(media.height);
        // image data
        const image_ctx = image!.getContext('2d');
        image_ctx!.drawImage(
            video!, 0, 0,
            Number(media.width), Number(media.height), 0, 0,
            image!.width, image!.height,
        );
        imgData = image!.toDataURL('image/jpeg');
        history.back();
    };
    // btn-flip
    btn_flip!.onclick = async () => {
        front = !front;
        options.video.facingMode = front ? 'user' : 'environment';
        stopMedia();
        camLoading(cam);
        await startMedia();
        camReady(cam);
    };
    // btn-close, btn-cancel
    btn_close!.onclick = () => history.back();
    btn_cancel!.onclick = () => history.back();
});
/*--------------------------------------------------------------------------------*/
const camCreate = (): HTMLElement => {
    const cam = document.createElement('div');
    cam.className = 'slim-camera';
    cam.innerHTML = /*html*/ `
        <div class="body">
            <video id="video" muted playsinline></video>
            <canvas id="image"></canvas>
        </div>
        <div class="header">
            <div style="text-align: center;">
                <div class="title">กล้องถ่ายภาพ</div>
                <div class="detail"></div>
            </div>
            <i id="btn-close" class="icon">&#xf00d;</i>
        </div>
        <div class="footer">
            <i id="btn-cancel" class="icon">&#xf057;</i>
            <button id="btn-take"></button>
            <i id="btn-flip" class="icon">&#xf021;</i>
        </div>
        <div class="loader">
            <div class="spinner s32"></div>
        </div>
    `;
    document.body.appendChild(cam);
    // open camera
    cam.style.left = `-100%`;
    cam.classList.add('cam-in');
    return cam;
};
/*--------------------------------------------------------------------------------*/
const camClose = (cam: HTMLElement) => {
    window.onhashchange = null;
    cam.classList.remove('cam-in');
    cam.classList.add('cam-out');
    cam.onanimationend = () => {
        cam.remove();
    };
};
/*--------------------------------------------------------------------------------*/
const camLoading = (cam: HTMLElement) => {
    const body = cam.querySelector<HTMLElement>('.body');
    const loader = cam.querySelector<HTMLElement>('.loader');
    body!.style.visibility = 'hidden';
    loader!.style.display = 'flex';
};
/*--------------------------------------------------------------------------------*/
const camReady = (cam: HTMLElement) => {
    const header = cam.querySelector<HTMLElement>('.header');
    const footer = cam.querySelector<HTMLElement>('.footer');
    const body = cam.querySelector<HTMLElement>('.body');
    const loader = cam.querySelector<HTMLElement>('.loader');
    header!.style.visibility = 'visible';
    footer!.style.visibility = 'visible';
    body!.style.visibility = 'visible';
    loader!.style.display = 'none';
};
/*--------------------------------------------------------------------------------*/
